import React from 'react'

function DueDilligence() {
  return (
    <div>DueDilligence</div>
  )
}

export default DueDilligence